import type * as React from 'react'
import { cn } from '../../lib/utils.ts'

export const Badge = ({ className, ...p }: React.ComponentProps<'span'>) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 rounded-[var(--radius-sm)] border px-1.5 py-0.5',
      'text-[length:var(--text-2xs)] font-semibold uppercase tracking-[var(--tracking-label)]',
      'border-[var(--border)] bg-[var(--muted)] text-[var(--muted-foreground)]',
      className,
    )}
    {...p}
  />
)
